import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-paginator-dumb',
    templateUrl: 'paginator-dumb.component.html',
    imports: [MatIconModule, MatButtonModule],
})
export class PaginatorDumbComponent {
    readonly collection = input.required<{
        page: number;
        next: boolean;
    }>();

    readonly page = output<number>();
}
